<template>
  <div>
    <!-- 顶部面包屑 -->
    <breadcrumbs></breadcrumbs>
    <!-- 头部搜索表单 -->
    <div class="header-form">
      <el-form :inline="true" ref="form" :model="form" label-width="80px">
        <el-form-item label="代理商编号">
          <el-input
            v-model="form.name"
            placeholder="请输入代理商编号"
          ></el-input>
        </el-form-item>
        <el-form-item label="代理商姓名">
          <el-input
            v-model="form.name"
            placeholder="请输入代理商姓名"
          ></el-input> </el-form-item
        ><el-form-item label="代理商手机号">
          <el-input
            v-model="form.name"
            placeholder="请输入代理商手机号"
          ></el-input>
        </el-form-item>
      </el-form>
      <el-form :inline="true" ref="form" :model="form" label-width="80px">
        <span class="mgr-12 mgl-30">注册时间</span>
        <el-date-picker
          v-model="form.date"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          size="small"
        >
        </el-date-picker>
        <el-form-item class="mgl-100">
          <el-button type="primary">查询</el-button>
          <el-button @click="form = {}">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 收益表格 -->
    <div class="table mgt-50">
      <div class="color052154 flex  f16 aic">
        <span class="mgr-80">总收益：¥####</span>
        <span class="mgr-80">已提现收益：¥####</span>
        <span>当前可提现收益：¥####</span>
      </div>
      <!-- ======== -->
      <el-table :data="tableData" border stripe style="width: 100%">
        <el-table-column
          type="index"
          :index="indexMethod"
          label="序号"
          width="80"
          fixed="left"
        >
        </el-table-column>
        <el-table-column prop="date" label="代理商编号" width="150">
        </el-table-column>
        <el-table-column prop="name" label="代理商姓名" width="150">
        </el-table-column>
        <el-table-column prop="province" label="代理商手机号" width="150">
        </el-table-column>
        <el-table-column prop="city" label="注册时间" width="150">
        </el-table-column>
        <el-table-column prop="address" label="账号状态" width="150">
        </el-table-column>
        <el-table-column prop="zip" label="总设备数（台）" width="150">
        </el-table-column>
        <el-table-column prop="zip" label="总订单数（笔）" width="150">
        </el-table-column
        ><el-table-column prop="zip" label="总收益（元）" width="150">
        </el-table-column
        ><el-table-column prop="zip" label="已提现收益（元）" width="150">
        </el-table-column
        ><el-table-column prop="zip" label="可提现收益（元）">
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="100">
          <template slot-scope="scope">
            <el-button @click="handleClick(scope.row)" type="text" size="small"
              >收益明细</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页器 -->
    <el-pagination
      class="mgt-20"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="page"
      :page-sizes="[5, 20, 30, 40, 50]"
      :page-size="pageSize"
      layout=" prev, pager, next"
      :total="total"
    >
    </el-pagination>
  </div>
</template>

<script>
import breadcrumbs from "@/components/breadcrumbs.vue";

export default {
  components: {
    breadcrumbs,
  },
  data() {
    return {
      form: {}, //头部表单查询
      tableData: [
        {
          date: "2016-05-02",
          name: "王小虎",
          province: "上海",
          city: "普陀区",
          address: "上海市普陀区金沙江路 1518 弄",
          zip: 200333,
        },
      ],
      // 分页数据
      page: 1, // 当前页，默认
      pageSize: 5, //每页显示多少条数据，默认
      total: 50, // 数据总条数
    };
  },
  methods: {
    //表格序号，根据索引+1
    indexMethod(index) {
      return index + 1;
    },
    // 表格收益明细按钮点击
    handleClick(row) {
      console.log(row);
      this.$router.push("/agentmanagement/agent_earnings/details_month");
    },
    // 分页事件
    // 每页显示多少条,条数改变时触发事件
    handleSizeChange(val) {
      console.log(val);
    },
    // 当前页面,当前页面改变时触发事件
    handleCurrentChange(val) {
      console.log(val);
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-form-item__label {
  width: 100px !important;
}
.el-date-editor,
.el-input {
  width: 250px;
}
// table表格标题
/deep/ .el-table__header .cell {
  color: var(--text-main) !important;
  font-weight: 600 !important;
}
</style>
